import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import styles from "./modal.module.less";
import { TActionObject } from "../../../types/modal-types";
import { OutlineIconButton } from "../button/button";
import { getModalPortal } from "../../../helpers/modal-helper";

type TModalProps = {
  isOpen?: boolean;
  children?: React.ReactNode;
  portalContainer?: HTMLElement | null;
  close?: TActionObject;
  modalOverlayClassName?: string;
  modalContentClassName?: string;
  onEscapeKeyDown?: () => void;
};

export const Modal = ({
  isOpen = false,
  children,
  portalContainer,
  close,
  modalOverlayClassName,
  modalContentClassName,
  onEscapeKeyDown,
}: TModalProps) => {
  const onClickOverlay = typeof close?.function === "function" ? close.function : undefined;

  return (
    <Dialog.Root open={isOpen}>
      <Dialog.Portal container={portalContainer ? portalContainer : getModalPortal()}>
        <Dialog.Overlay onClick={onClickOverlay} className={[modalOverlayClassName, styles.modalOverlay].join(" ")} />
        <Dialog.Content
          onInteractOutside={onClickOverlay}
          onEscapeKeyDown={onEscapeKeyDown}
          className={[modalContentClassName, styles.content].join(" ")}
        >
          <div className={styles.buttonWrapper}>
            {typeof close?.function === "function" && (
              <OutlineIconButton
                className={styles.closeButton}
                icon={close?.icon ?? "ui-icon-close"}
                onClick={close?.function}
              />
            )}
          </div>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default Modal;
